export enum Section {
  Admin = 'team',
  Main = 'glapp',
}

export interface AppConfig {
  adminName: string;
  app: string;
  appName: string;
  privacyPage?: string;
  procuriosImport?: boolean;
  omniauthProvider?: string;
}

export type Globals = {
  adminRoot: string;
  config: AppConfig;
  currentRoot: string;
  mainRoot: string;
  section: Section;
};

/**
 * These are injected through webpack.
 */
declare global {
  const __PRODUCTION__: boolean;
  const __TEST__: boolean;

  const GLOBALS: Globals;
}
